/**
 * Global Developer Mode entry point.
 *
 * Mounts once at the app root. Renders the floating DEV pill that
 * opens Voice Diagnostics on tap. The pill is always visible during
 * development — when we get closer to TestFlight we'll gate it behind
 * a build-time flag, but keeping it accessible right now beats
 * dealing with a gesture that false-triggers on typing and tapping.
 *
 * The `useDeveloperMode` hook still controls whether in-app dev
 * annotations (like the "recognized · learned · new" session pill)
 * render. The toggle lives inside the Voice Diagnostics modal so it
 * never gets hit by accident.
 */
import { useEffect, useState } from "react";

import { useDevRecordScreen } from "@/hooks/useDevRecordScreen";

import { DevPill } from "./DevPill";
import { VoiceDiagnostics } from "./VoiceDiagnostics";

export function DevGate() {
  const [open, setOpen] = useState(false);
  const recordScreenOpen = useDevRecordScreen();

  // Closing the diagnostics modal when the record screen opens keeps
  // the user from having to manually dismiss it first. "Open record
  // controls" acts as "switch view" instead of "stack a second sheet."
  useEffect(() => {
    if (recordScreenOpen) setOpen(false);
  }, [recordScreenOpen]);

  return (
    <>
      <DevPill onOpen={() => setOpen(true)} />
      {open && <VoiceDiagnostics onClose={() => setOpen(false)} />}
    </>
  );
}
